<template>
  <div class="consultation">
    <com-list :data="coStyle" title="合作形式"></com-list>
    <co-area></co-area>
    <com-service></com-service>
    <com-tea></com-tea>
    <com-partner :partners="partners"></com-partner>
  </div>
</template>
<script>
import comList from '@/view/training/com-list'
import comService from './com-service'
import coArea from './co-area'
import comTea from './com-tea'
import comPartner from '../com-partner'
export default {
  data () {
    return {}
  },
  components: {
    comList,
    coArea,
    comService,
    comTea,
    comPartner
  },
  computed: {
    coStyle () {
      return [{
        img: 'http://static.geekbang.org/infoq/5a27a53651d01.png?imageView2/0/',
        title: '公开课',
        word: '为来自不同企业的技术人员提供人工智能、大数据、架构、移动与前端、运维容器、技术管理等不同技术领域的实践驱动的系统培训课程，1-2天深度培训，线下公开课形式，全年在全国各地开展。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a27b732d954f.png?imageView2/0/',
        title: '企业内训',
        word: ' 根据企业研发团队技术能力培养需求，为企业定制培训课程，邀请特约讲师到企业内部与研发团队面对面进行系统化技术课程辅导，提升企业整体研发能力。'
      }, {
        img: 'http://static.geekbang.org/infoq/5a27a5374a189.png?imageView2/0/',
        title: '技术咨询',
        word: '为企业提供具体技术问题的咨询服务，包含但不限于以下领域：架构优化、微服务架构、运维优化、容器化调度、大数据、人工智能技术、工程效率、技术管理。'
      }]
    },
    partners () {
      return [{
        link: 'http://www.alibabagroup.com/cn/global/home',
        img: 'http://7xil0e.com1.z0.glb.clouddn.com/picture/566d4a2ac5483.png'
      }, {
        link: 'http://www.huawei.com/cn/',
        img: 'http://static.geekbang.org/infoq/5a2680fe56d9e.png?imageView2/0/'
      }, {
        link: 'http://www.gome.com.cn',
        img: 'http://static.geekbang.org/infoq/5a26817b427e4.png?imageView2/0/w/160'
      }, {
        link: 'http://www.ha.org.hk/',
        img: 'http://static.geekbang.org/infoq/5a26817a38ee5.png?imageView2/0/w/160'
      }, {
        link: 'http://tech.pingan.com',
        img: 'http://static.geekbang.org/infoq/5a26817c2d9d4.png?imageView2/0/w/160'
      }, {
        link: 'http://www.sf-express.com/cn/sc/',
        img: 'http://static.geekbang.org/infoq/5a26817cddecd.png?imageView2/0/w/160'
      }, {
        link: 'https://www.vip.com',
        img: 'http://static.geekbang.org/infoq/5a268179eda98.png?imageView2/0/w/160'
      }, {
        link: 'http://www.citicbank.com',
        img: 'http://static.geekbang.org/infoq/5a26817aece3f.png?imageView2/0/w/160'
      }, {
        link: 'http://www.99fund.com',
        img: 'http://static.geekbang.org/infoq/5a26817b8b00b.png?imageView2/0/w/160'
      }, {
        link: 'https://www.wens.com.cn',
        img: 'http://static.geekbang.org/infoq/5a276d3a9fa97.png?imageView2/0/w/160'
      }]
    }
  }
}
</script>
<style scoped lang='sass'>

div.consultation
  background-color: #f7f8f8
</style>
